import * as React from 'react';
import axios from 'axios';
import { IMedia } from '../../interfaces';
import config from '../../config';
import Film from '../items/Film';
import { connect } from 'react-redux';
import { showModal } from '../../actions/modal';
import { NavLink } from 'react-router-dom';
import { withTranslation, WithTranslation } from 'react-i18next';
import i18n from '../../config/i18next';

interface IState {
    isLoading: boolean,
    last: IMedia[],
    popular: IMedia[],
    favorite: IMedia[],
    filter: string,
    options: any,
    [key: string]: any
}

interface IProps extends WithTranslation {
    person_id: number,
    t: any,
    auth: any,
    showModal: any
}

class AsActor extends React.Component<IProps, IState> {
    private _isUnmounted: boolean = false;

    public state: IState = {
        isLoading: true,
        popular: [],
        favorite: [],
        last: [],
        filter: "last",
        options: {
            loop: false,
            margin: 30,
            nav: true,
            // autoplay: true,
            // autoplayTimeout: 8000,
            autoHeight: true,
            responsive: {
                0: {
                    items: 1
                },
                400: {
                    items: 2
                },
                600: {
                    items: 2
                },
                800: {
                    items: 3
                },
                1000: {
                    items: 5
                }
            },
        }
    }

    constructor(props: IProps) {
        super(props);
    }

    async componentDidMount() {
        try {
            await this.loadFilms(this.state.filter);
        } catch (e) {

        }
    }

    componentWillUnmount() {
        this._isUnmounted = true;;
    }

    async loadFilms(order: string) {
        $('#carusel2').owlCarousel("destroy");

        this.setState({
            isLoading: true
        }, async () => {
            if (this.state[order].length == 0) {
                let { data } = await axios.get(`${config.site}/${i18n.language}/api/person/as-actor?person_id=${this.props.person_id}&order=${order}`);

                if (this._isUnmounted) return;

                this.setState({
                    [order]: data,
                    isLoading: false,
                    filter: order
                }, this.carouselInit);
            } else {
                this.setState({
                    isLoading: false,
                    filter: order
                }, this.carouselInit);
            }
        })
    }

    carouselInit() {
        $('#carusel2').owlCarousel(this.state.options);

        $(window).ready(function () {
            setTimeout(function () {
                $('.owl-carousel').trigger('refresh.owl.carousel');
            }, 50);
        });
    }

    render() {
        const { t } = this.props;

        return (
            <div className="films">

                <nav>
                    <div>
                        <a className="film cursor-default"> {t("Как актёр")} </a>
                    </div>
                    <div>
                        <a onClick={async (event: React.MouseEvent) => {
                            event.preventDefault();
                            await this.loadFilms("last");
                        }} className={this.state.filter == "last" ? "active" : ""}> {t("Новые")} </a>

                        <a onClick={async (event: React.MouseEvent) => {
                            event.preventDefault();
                            await this.loadFilms("popular");
                        }} className={this.state.filter == "popular" ? "active" : ""}> {t("Популярные")} </a>
                    </div>
                    <div>
                    </div>
                </nav>

                {this.state.isLoading && (<div className="carousel-placeholder"></div>)}
                {this.state[this.state.filter].length > 0 && <div className="owl-carousel" id="carusel2">
                    {this.state[this.state.filter].map((slide: IMedia, index: number) => {
                        return (
                            <Film key={index} slide={slide} />
                        );
                    })}
                </div>}
                {this.state[this.state.filter].length == 0 && !this.state.isLoading && <h3 className="text-center">{t("Ничего не найдено")}</h3>}
            </div>
        );
    }
}

function mapStateToProps(state: any) {
    return {
        modal: state.modal,
        auth: state.auth,
    };
}

export default connect(mapStateToProps, { showModal })(withTranslation()(AsActor));